import React from 'react';
import PropTypes from 'prop-types';
import StackScrollerHorizontal from '../UI/StackScrollerHorizontal';
import handlePlural from '../../../util/handlePlural';
import { connectToShelves } from '../containers/ShelvesDataStore';
import { connectToTitle } from '../../Title/containers/TitleDataStore';
import combineConnectors from '../../util/combineConnectors';
import ShelfType from '../ShelfType';
import { connectToCollections } from '../../Collections/containers/CollectionsDataStore';
import api from '../../../Api';
import { message } from 'antd';
import { connectToCollectionTitles } from '../../Collections/containers/CollectionTitlesDataStore';
import AddEditCollection from '../../Collections/AddEditCollection';

export class ShelfSelect extends React.Component {
	constructor(props) {
		super(props);
		this.processStackClick = this.processStackClick.bind(this);
		this.state = {
			selectedStacks: [],
			changeState: 0,
		};
	}

	static propTypes = {
		skus: PropTypes.string,
		children: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
		parentStyle: PropTypes.string,
	};

	render() {
		const { skus, sku } = this.props;
		const { selectedStacks } = this.state;
		return (
			<div
				style={{
					padding: '15px',
					margin: '15px',
					backgroundColor: '#ffffff',
				}}>
				<div>
					{skus ? (
						<div className="column" style={{ fontSize: '18px' }}>
							Select 1 or more Stacks below to add the{' '}
							{handlePlural('selected title', skus.length, false)}{' '}
							to...
						</div>
					) : (
						<div className="column" style={{ fontSize: '18px' }}>
							Select 1 or more Stacks below to add the title to...
						</div>
					)}
					<div className="column-spaced-right">
						<AddEditCollection sku={sku} skus={skus} />
					</div>
					<div className="clear" />
				</div>
				<div>
					<StackScrollerHorizontal
						processStackClick={this.processStackClick}
						selectedStacks={selectedStacks}
						allowMultipleSelections={true}
						sku={sku}
					/>
				</div>
			</div>
		);
	}

	processStackClick = (selectedStacks, thisStack, action) => {
		this.setState({ selectedStacks, changeState: 1 });
		if (thisStack.stackType === 'shelf') {
			if (action === 'add') {
				this.toggleShelf(thisStack.key);
			} else {
				this.toggleShelf(ShelfType.Clear.key);
			}
		} else {
			if (action === 'add') {
				this.addToCollection(thisStack.key);
			} else {
				this.removeFromCollection(thisStack.key);
			}
		}
	};

	toggleShelf = thisShelf => {
		const { skus, sku } = this.props;
		var theseSkus = [];
		!skus ? theseSkus.push(sku) : (theseSkus = skus);
		this.props.shelvesDataStore.setShelves(theseSkus, thisShelf);
	};

	addToCollection = catalogId => {
		const { skus, sku } = this.props;
		var theseSkus = [];
		!skus ? theseSkus.push(sku) : (theseSkus = skus);
		api.post(`/api/v1/me/collections/${catalogId}`, theseSkus).then(() => {
			this.props.collectionsDataStore.refresh();
			this.props.titleDataStore &&
				this.props.titleDataStore.refreshCollectionData();
			message.success(
				<span>
					You've added{' '}
					{skus && skus.length > 1 ? 'these titles' : 'this title'} to
					the collection
				</span>,
			);
		});
	};

	removeFromCollection = catalogId => {
		const { sku } = this.props;
		api.del(`/api/v1/me/collections/${catalogId}/${sku}`).then(() => {
			this.props.collectionsDataStore.refresh();
			this.props.titleDataStore &&
				this.props.titleDataStore.refreshCollectionData();
			this.props.collectionTitlesDataStore &&
				this.props.collectionTitlesDataStore.refresh();
			message.success(
				<span>You've removed this title from the collection</span>,
			);
		});
	};
}

const connectors = [
	connectToShelves,
	connectToTitle,
	connectToCollections,
	connectToCollectionTitles,
];

export default combineConnectors(connectors)(ShelfSelect);
